import type React from 'react'
import { forwardRef } from 'react'

import * as SliderPrimitive from '@radix-ui/react-slider'

import { classNames } from '@/utils/helpers'

const SliderThumb = forwardRef<
  React.ElementRef<typeof SliderPrimitive.Thumb>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Thumb> & {
    value: number[]
  }
>((props, ref) => (
  <SliderPrimitive.Thumb
    ref={ref}
    className={classNames(
      'relative block h-6 w-6 cursor-pointer rounded-full border-4 border-primary-500 bg-white ring-offset-background transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50',
      props.className,
    )}
    {...props}
  >
    <div className="absolute -top-[calc(100%+16px)] left-1/2 -translate-x-1/2 rounded bg-card px-1.5 py-[3px] text-xs font-medium leading-5 text-title shadow dark:bg-secondary-500">
      {props.value}
    </div>
  </SliderPrimitive.Thumb>
))

SliderThumb.displayName = SliderPrimitive.Thumb.displayName

export const CountdownMinutesSlider = forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={classNames(
      'relative flex w-full touch-none select-none items-center pt-11',
      className,
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary-10 dark:bg-primary-800">
      <SliderPrimitive.Range className="absolute h-full bg-primary-500" />
    </SliderPrimitive.Track>
    <SliderThumb
      value={props.value ?? [0]}
      className="block h-5 w-5 rounded-full border-2 border-white bg-primary-500 shadow ring-offset-background transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 dark:border-secondary-700"
    />
  </SliderPrimitive.Root>
))

CountdownMinutesSlider.displayName = 'CountdownMinutesSlider'
